import IndividualPrintsOption from './IndividualPrintsOption';

export default IndividualPrintsOption;
